import {recent_channel_action} from "../actions/recent.channel";


const inited = {
    data: null
};

export default function recentChannelReducer(state = inited, action) {
    switch (action.type) {
        case recent_channel_action:
            return {
                ...state,
                ...(action.hasOwnProperty('payload') ? action.payload : inited)
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/libs/redux/reducres/recent.channel.js